// Load External Libraries
import AOS from 'aos'
import 'owl.carousel';
//import {jarallax, jarallaxVideo} from 'jarallax';
import {Fancybox} from "@fancyapps/ui";

// other packages here...

import {menuButton, stickyHeader} from "./modules/_header.mjs";

window.$ = window.jQuery = jQuery;

//Load Bootstrap Libraries
//import 'bootstrap/js/dist/alert';
//import 'bootstrap/js/dist/button';
//import 'bootstrap/js/dist/carousel';
//import 'bootstrap/js/dist/collapse';
//import 'bootstrap/js/dist/dropdown'; //also requires Popper
//import 'bootstrap/js/dist/modal';
//import 'bootstrap/js/dist/offcanvas';
//import 'bootstrap/js/dist/popover'; //also requires Popper
//import 'bootstrap/js/dist/scrollspy';
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/toast';
//import Tooltip from 'bootstrap/js/dist/tooltip'; //also requires Popper

//Local imports
import { serviceWorker } from './modules/_serviceWorker.mjs';
import { validate } from './modules/_validate.mjs';
import { exampleSlider } from "./modules/_carousels.mjs";
import {homeIntroSlider} from "./modules/_home-intro.mjs";
import {clientCarousel} from "./modules/_client.mjs";
import {footer} from "./modules/_footer.mjs";
import {aosDelay, utilities} from "./modules/_utilities.mjs";
import {projectsCarousel} from "./modules/_projects.mjs";
import {smallUSPSCarousel} from "./modules/_small-usps.mjs";

//initialize functions
document.addEventListener("DOMContentLoaded", function() {
    AOS.init({
        disable: 'mobile',
        once: true
    });
    // Loader

    setTimeout(function() {
        $('.js-loader').addClass('is-hidden');
    }, 2000);

    serviceWorker();
    validate();
    stickyHeader();
    menuButton();
    homeIntroSlider();
    clientCarousel();
    footer();
    utilities();
    projectsCarousel();
    smallUSPSCarousel();
    aosDelay();
    //exampleSlider()
    //jarallax(document.querySelectorAll('.jarallax'), { speed: 0.5 });
    //jarallaxVideo();


    $(window).scroll(function() {
       stickyHeader();
    });

    $(window).resize(function() {
       clientCarousel();
       projectsCarousel();
       smallUSPSCarousel();
    });
});